import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/SalesOrderDocumentTypes'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class SalesOrderDocumentTypesStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "SalesOrderDocumentTypesStore",
			variables: false,
		})
	}
}

export async function load_SalesOrderDocumentTypes(params) {
  await initClient()

	const store = new SalesOrderDocumentTypesStore()

	await store.fetch(params)

	return {
		SalesOrderDocumentTypes: store,
	}
}
